import { Directive } from '@angular/core';

@Directive({
  selector: 'button[sidebar-button]',
  standalone: true,
  host: {
    class: 'sidemenu-button d-flex flex-column justify-content-center align-items-center cursor-pointer'
  }
})
export class SidebarButtonDirective {
}
